import http from "@/api/http.js";

export function getStores() {
  return http.get("/stores").then(res => {
    return res;
  });
}
export function sendImproveRequest(params) {
  return http
    .post("/requests", params)
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}
